import * as Tiers from './Tier';
export const CRM = [Tiers.HUBSPOT_FREE];
export const OPERATIONS = [Tiers.OPS_STARTER, Tiers.OPS_PROFESSIONAL, Tiers.OPS_ENTERPRISE];
export const MARKETING = [Tiers.MARKETING_STARTER, Tiers.MARKETING_PROFESSIONAL, Tiers.MARKETING_ENTERPRISE];
export const SALES = [Tiers.SALES_STARTER, Tiers.SALES_PROFESSIONAL, Tiers.SALES_ENTERPRISE];
export const SERVICE = [Tiers.SERVICE_STARTER, Tiers.SERVICE_PROFESSIONAL, Tiers.SERVICE_ENTERPRISE];
export const CMS = [Tiers.CMS_STARTER, Tiers.CMS_STANDALONE, Tiers.CMS_ENTERPRISE];